<template>
  <div id="dashboard-modal">
    <div v-if="showModal" class="modal-backdrop show"></div>
    <div v-if="showModal" class="modal show" style="display: block" role="dialog">
      <div class="modal-dialog modal-dialog-centered" v-click-outside="clickOutsideConfig">
        <div class="modal-content">
          <button type="button" class="close-modal" aria-label="Close" @click="closeModal"><font-awesome-icon icon="times-circle" /></button>
          <h3>How should I use this dashboard?</h3>
          <p>This is an interactive dashboard featuring a summary of the second by second (1Hz) data collected from NLR's <a href="https://www.nlr.gov/transportation/fleettest-fleet-dna.html">Fleet DNA tool</a>. It allows users to:</p>
          <ul>
            <li>Explore operational data coverage (geographic, vehicle type, use case)</li>
            <li>Filter according to weight class and use case </li>
            <li>Gain high level insights on vehicle operational characteristics </li>
            <li>Examine duty cycle characteristics for a given vehicle selection </li>
            <li>Download graphs and data of summary statistics. </li>
          </ul>
          <p>To get detailed data, select a vehicle vocation and/or a vehicle weight class</p>
          <p><em>Note: Data comprises a variety of vehicle types, applications, and powertrains but should not be considered representative of national operations.</em></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onUnmounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const showModal = computed(() => store.getters.getShowDashboardModal);

function closeModal() {
  store.commit('setDashboardModal', false);
}

const clickOutsideConfig = {
  detectIframe: false,
  handler: () => {
    closeModal();
  },
};

const keyFunc = (e) => e.key === 'Escape' && closeModal();

document.addEventListener('keydown', keyFunc);

onUnmounted(() => document.removeEventListener('keydown', keyFunc));

</script>
